import React from 'react';
import { useSelector } from 'react-redux';

import BreederProfilePopularCities from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfilePopularCities';
import BreederProfilePopularStates from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfilePopularStates';
import BreederProfileBreedOverviewPages from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfileBreedOverviewPages';

export default function BreedRelatedLinks() {
  const { breedData } = useSelector(({ server }) => server);

  return (
    <div className="BreedRelatedLinks ph5 pt10 ph20-md">
      <BreederProfilePopularCities
        breedName={breedData.name}
        breedId={breedData.id}
      />
      <BreederProfilePopularStates
        breedName={breedData.name}
        breedId={breedData.id}
      />
      <BreederProfileBreedOverviewPages limit={10} />
    </div>
  );
}
